/**
 * OnlyPaithani Contact Us Interactive JavaScript
 * Handles FAQ accordion interactions & smooth scroll anchors
 * Compatible with Shopify Theme Editor (OS 2.0 section re-renders)
 */

document.addEventListener('DOMContentLoaded', () => {
  initOnlyPaithaniContact();
});

function initOnlyPaithaniContact() {
  initFaqAccordions();
  initSmoothScroll();
}

/**
 * FAQ Accordion Controller
 */
function initFaqAccordions() {
  const faqSections = document.querySelectorAll('.op-contact-faq');

  faqSections.forEach((section) => {
    const allowMultiple = section.dataset.allowMultiple === 'true';
    const triggers = section.querySelectorAll('.op-contact-faq__trigger');

    triggers.forEach((trigger) => {
      // Remove existing listener to prevent duplicate listeners on theme editor updates
      trigger.removeEventListener('click', handleFaqClick);
      trigger.addEventListener('click', handleFaqClick);
    });

    function handleFaqClick(e) {
      const currentTrigger = e.currentTarget;
      const controlsId = currentTrigger.getAttribute('aria-controls');
      const panel = document.getElementById(controlsId);
      const isExpanded = currentTrigger.getAttribute('aria-expanded') === 'true';

      if (!panel) return;

      if (!allowMultiple && !isExpanded) {
        // Close all other panels in this section
        triggers.forEach((otherTrigger) => {
          if (otherTrigger !== currentTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            const otherPanelId = otherTrigger.getAttribute('aria-controls');
            const otherPanel = document.getElementById(otherPanelId);
            if (otherPanel) {
              otherPanel.classList.remove('op-contact-faq__panel--active');
              otherPanel.setAttribute('hidden', '');
            }
          }
        });
      }

      // Toggle current panel
      if (isExpanded) {
        currentTrigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('op-contact-faq__panel--active');
        panel.setAttribute('hidden', '');
      } else {
        currentTrigger.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
        panel.classList.add('op-contact-faq__panel--active');
      }
    }
  });
}

/**
 * Smooth Scroll to Anchor Links
 */
function initSmoothScroll() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');

  anchorLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href').substring(1);
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        e.preventDefault();
        targetEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        // Optional focus management for accessibility
        targetEl.setAttribute('tabindex', '-1');
        targetEl.focus({ preventScroll: true });
      }
    });
  });
}

/* Shopify Theme Editor Hooks */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initOnlyPaithaniContact();
  });

  document.addEventListener('shopify:section:select', (event) => {
    initOnlyPaithaniContact();
  });
}
